import request from './request'


//获取产业智库
const getResearchReportApi = async (data) => {
    try {
        return await request.post(`/website/getResearchReport`, data);
    } catch (error) {
        console.log(error);
        return error;
    }
};

//产业智库详情
const getResearchReportDetailApi = async (data) => {
    try {
        return await request.post(`/website/getResearchReportDetail/${data}`);
    } catch (error) {
        console.log(error);
        return error;
    }
};
//会员风采
const getVipDescribeApi = async (data) => {
    try {
        return await request.post(`/website/getVipDescribe`, data);
    } catch (error) {
        console.log(error);
        return error;
    }
};

// 获取通知公告
const getNoticeApi = async (data) => {
    try {
        return await request.post(`/website/getNotice`, data);
    } catch (error) {
        console.log(error);
        return error;
    }
};

//获取协会要闻
const getNewsApi = async (data) => {
    try {
        return await request.post(`/website/getNews`, data);
    } catch (error) {
        console.log(error);
        return error;
    }
};


// 会员动态
const getVipApi = async (data) => {
    try {
        return await request.post(`/website/getVip`, data);
    } catch (error) {
        console.log(error);
        return error;
    }
};

// 产业动态
const getPropertyApi = async (data) => {
    try {
        return await request.post(`website/getProperty`, data);
    } catch (error) {
        console.log(error);
        return error;
    }
};



// 通知公告详情
const getNoticeDetailApi = async (data) => {
    try {
        return await request.post(`/website/getNoticeDetail/${data}`);
    } catch (error) {
        console.log(error);
        return error;
    }
};


// 产业动态详情
const getPropertyDetailApi = async (data) => {
    try {
        return await request.post(`/website/getPropertyDetail/${data}`);
    } catch (error) {
        console.log(error);
        return error;
    }
};


// 会员动态详情
const getVipDetailApi = async (data) => {
    try {
        return await request.post(`/website/getVipDetail/${data}`);
    } catch (error) {
        console.log(error);
        return error;
    }
};

// 协会要闻详情
const getNewsDetailApi = async (data) => {
    try {
        return await request.post(`/website/getNewsDetail/${data}`);
    } catch (error) {
        console.log(error);
        return error;
    }
};

// 会员风采详情
const getVipDescribeDetailApi = async (data) => {
    try {
        return await request.post(`/website/getVipDescribeDetail/${data}`);
    } catch (error) {
        console.log(error);
        return error;
    }
};
// 会员网络
const getVipMemberApi = async () => {
    try {
        return await request.post(`/website/getVipMember`);
    } catch (error) {
        console.log(error);
        return error;
    }
};

// 获取规章制度
const getInstituteApi = async () => {
    try {
        return await request.post(`/website/getInstitute`);
    } catch (error) {
        console.log(error);
        return error;
    }
};

// 更新规章制度浏览次数
const updateInstituteDetailApi = async (data) => {
    try {
        return await request.post(`/website/updateInstituteDetail/${data}`);
    } catch (error) {
        console.log(error);
        return error;
    }
};

// 获取首页内容
const getIndexContentApi = async () => {
    try {
        return await request.post(`/website/getIndexContent`);
    } catch (error) {
        console.log(error);
        return error;
    }
};
export default {
    getResearchReportApi,
    getVipDescribeApi,
    getResearchReportDetailApi,
    getNoticeApi,
    getNewsApi,
    getVipApi,
    getPropertyApi,
    getNoticeDetailApi,
    getPropertyDetailApi,
    getVipDetailApi,
    getNewsDetailApi,
    getVipDescribeDetailApi,
    getVipMemberApi,
    getInstituteApi,
    updateInstituteDetailApi,
    getIndexContentApi
};